import { useCallback } from 'react';

/**
 * Accessibility skip link component.
 * Allows keyboard users to bypass navigation and jump to main content.
 * Required by WCAG 2.1 Level A Success Criterion 2.4.1.
 * 
 * The skip link is visually hidden until focused via keyboard navigation.
 */
export function SkipLink() {
    const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        const mainContent = document.getElementById('main-content');

        if (mainContent) {
            mainContent.focus();
            mainContent.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    return (
        <a
            href="#main-content"
            onClick={handleClick}
            className="skip-link"
            aria-label="Skip to main content"
        >
            Skip to main content
        </a>
    );
}

export default SkipLink;
